/**
 * @export
 * @function
 * @param {string} id An optional custom id
 * @param {string} label An optional label for the close button
 * @return {string}
 */
export let lightboxTpl = function(id = 'lightbox', label='Fermer') {
    return `<div id="${id}" class="lightbox">
                <div class="lightbox__scroll">
                    <div class="lightbox__bg js-lightbox-close"></div>
                    <div class="lightbox__scroll-inner">
                        <div class="lightbox__container">
                            <div class="lightbox__content js-lightbox-content"></div>
                            <button type="button" class="lightbox__close-button js-lightbox-close">
                                <span class="lightbox__close-text">${label}</span>
                                <svg class="lightbox__close-icon ico ico--close">
                                    <use xlink:href="#close"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>`;
};



// WEBPACK FOOTER //
// ./src/main/js/templates/lightboxTpl.js